// components/ExpenseFormModal.jsx
import React, { useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { FileUpload } from 'primereact/fileupload';
import { Button } from 'primereact/button';
import { useForm, Controller } from 'react-hook-form';
import { extractFieldErrors } from '../utils/formErrorUtils';

const ExpenseFormModal = ({ visible, onHide, expenseTypes, onSubmit }) => {
  const {
    control,
    handleSubmit,
    reset,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      amount: null,
      reason: '',
      expense_date: null,
      expense_type_id: null,
      doc_file: null,
    },
  });

  useEffect(() => {
    if (!visible) {
      reset();
    }
  }, [visible, reset]);

  const submit = async (data) => {
    try {
      await onSubmit(data);
    } catch (error) {
      if (error?.response?.status === 422) {
        extractFieldErrors(error).forEach(({ field, message }) => {
          setError(field, { type: 'server', message });
        });
      }
    }
  };

  return (
    <Dialog header="Yeni Harcama Ekle" visible={visible} style={{ width: '500px' }} modal onHide={onHide}>
      <form onSubmit={handleSubmit(submit)} className="p-fluid">
        <label>Tutar</label>
        <Controller
          name="amount"
          control={control}
          rules={{
            required: 'Tutar zorunludur',
            validate: (value) => value > 0 || 'Tutar pozitif olmalıdır',
          }}
          render={({ field }) => (
            <InputNumber
              value={field.value}
              onValueChange={(e) => field.onChange(e.value)}
              mode="currency"
              currency="TRY"
              locale="tr-TR"
              minFractionDigits={2}
              maxFractionDigits={2}
              step={0.01}
              showButtons
              className={`mb-2 ${errors.amount ? 'p-invalid' : ''}`}
            />
          )}
        />
        {errors.amount && <small className="p-error">{errors.amount.message}</small>}

        <label>Açıklama</label>
        <Controller
          name="reason"
          control={control}
          rules={{ required: 'Açıklama zorunludur' }}
          render={({ field }) => (
            <InputText {...field} className={`mb-2 ${errors.reason ? 'p-invalid' : ''}`} />
          )}
        />
        {errors.reason && <small className="p-error">{errors.reason.message}</small>}

        <label>Harcama Tarihi</label>
        <Controller
          name="expense_date"
          control={control}
          rules={{ required: 'Tarih zorunludur' }}
          render={({ field }) => (
            <div className="p-inputgroup mb-2" style={{ width: '100%' }}>
              <Calendar
                value={field.value}
                onChange={(e) => field.onChange(e.value)}
                showTime
                showSeconds
                hideOnDateTimeSelect={false}
                dateFormat="dd.mm.yy"
                className={`w-full ${errors.expense_date ? 'p-invalid' : ''}`}
              />
              {field.value && (
                <Button
                  type="button"
                  icon="pi pi-times"
                  className="p-button-text p-button-rounded p-button-icon-only p-button-sm"
                  onClick={() => field.onChange(null)}
                  aria-label="Tarihi temizle"
                />
              )}
            </div>
          )}
        />
        {errors.expense_date && <small className="p-error">{errors.expense_date.message}</small>}

        <label>Harcama Tipi</label>
        <Controller
          name="expense_type_id"
          control={control}
          rules={{ required: 'Harcama tipi seçilmelidir' }}
          render={({ field }) => (
            <Dropdown
              {...field}
              value={field.value}
              options={expenseTypes}
              onChange={(e) => field.onChange(e.value)}
              placeholder="Seçiniz"
              className={`mb-2 ${errors.expense_type_id ? 'p-invalid' : ''}`}
            />
          )}
        />
        {errors.expense_type_id && (
          <small className="p-error">{errors.expense_type_id.message}</small>
        )}

        <label>Belge</label>
        <Controller
          name="doc_file"
          control={control}
          rules={{ required: 'Belge yüklenmelidir' }}
          render={({ field }) => (
            <>
              <FileUpload
                customUpload
                uploadHandler={(e) => field.onChange(e.files[0])}
                auto
                chooseLabel="Dosya Seç"
                mode="basic"
                accept="image/*"
                maxFileSize={1000000}
                className={`mb-1 ${errors.doc_file ? 'p-invalid' : ''}`}
              />
              {field.value && (
                <div className="mb-3" style={{ fontSize: '0.9rem', color: '#555' }}>
                  Seçilen dosya: {field.value.name}
                </div>
              )}
            </>
          )}
        />
        {errors.doc_file && <small className="p-error">{errors.doc_file.message}</small>}

        <div className="text-right mt-3">
          <Button label="Kaydet" icon="pi pi-check" type="submit" />
        </div>
      </form>
    </Dialog>
  );
};

export default ExpenseFormModal;
